import './index.css'

const SalaryRangeItem = props => {
  const {salaryRangeDetails, onChangePackage} = props
  const {salaryRangeId, label} = salaryRangeDetails
  const onChangeSalary = () => {
    onChangePackage(salaryRangeId)
  }
  return (
    <li className="list-item">
      <input
        onChange={onChangeSalary}
        className="radio"
        id={salaryRangeId}
        type="radio"
        name="salary"
      />
      <label className="label" htmlFor={salaryRangeId}>
        {label}
      </label>
    </li>
  )
}
export default SalaryRangeItem
